module.exports = __webpack_public_path__ + "static/powerofcloudHeader2-cc92280487c8d313fc2cb6d9e14712d9.png";